import React from "react";
import ReactDOM from "react-dom/client";
import App, { router } from "./App";
import { AppearanceProvider } from "./Utilities/appearance";
import "./index.css";
import "./thirdPartyDark.css";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";

// The theme (colour scheme, theme colour, brand palette, Poppins, phone rules) lives in
// AppearanceProvider. It gets the router so the sign-in page and the printable proposal stay light.
ReactDOM.createRoot(document.getElementById("root")).render(
  <AppearanceProvider router={router}>
    <App />
  </AppearanceProvider>
);
